import type { UiMessages } from "../types";

export const fr: UiMessages = {
  nav: {
    streams: "Streams",
    videos: "Vidéos",
    shorts: "Shorts",
    forYou: "Pour vous",
    vr: "VR",
    cartoon: "Cartoons",
    hentai: "Hentai",
    sections: "Plus",
    menu: "Menu",
    game: "Jeu porno",
    stories: "Histoires de sexe",
    escorts: "Escortes",
    ai: "Copines IA",
    paysites: "Sites premium",
    home: "Accueil",
    following: "Abonnements",
    watching: "En cours",
    rankings: "Classements",
    invite: "Inviter des amis",
    coins: "Sweet Coin",
    achievements: "Succès",
    hot: "Chaud en ce moment",
    random: "Vidéo au hasard",
    saved: "Enregistrés",
    reacted: "Réactions",
    boost: "Sweet Boost",
    premium: "Premium",
    stars: "Pornstars",
    productions: "Studios",
    categories: "Catégories",
    telegram: "Chaîne Telegram",
    allSections: "Toutes les rubriques",
    mainNavigation: "Navigation principale",
    quickNavigation: "Navigation rapide",
    show: "Afficher",
    coinsReady: "Sweet Coins à récupérer",
    logIn: "Connexion",
    search: "Rechercher",
    closeSearch: "Fermer la recherche",
    language: "Langue",
    theme: "Thème",
    themeDark: "Sombre",
    themeLight: "Clair",
  },
  age: {
    parents: "Parents : notre page {link} explique comment bloquer l’accès à ce site. Sweet porte le label RTA.",
    parentalControls: "contrôle parental",
    title: "Ceci est un site pour adultes",
    body: "Ce site contient du contenu réservé aux adultes, notamment de la nudité et des représentations explicites d’activités sexuelles. En entrant, tu confirmes avoir au moins 18 ans, ou l’âge de la majorité dans le pays depuis lequel tu accèdes au site, et accepter de voir du contenu sexuellement explicite.",
    enter: "J’ai 18 ans ou plus — Entrer",
    exit: "J’ai moins de 18 ans — Sortir",
  },
  consent: {
    title: "Cookies",
    body: "Sweet est gratuit grâce à la pub. Nos partenaires publicitaires utilisent des cookies pour afficher les annonces et compter leurs vues et leurs clics. Le stockage nécessaire, comme ta confirmation d’âge, fonctionne dans tous les cas.",
    privacy: "Politique de confidentialité",
    acceptAll: "Tout accepter",
    onlyNecessary: "Nécessaires uniquement",
    settings: "Paramètres des cookies",
  },
  ago: { now: "à l’instant", m: "{n} min", h: "{n} h", d: "{n} j", w: "{n} sem", mo: "{n} mois", y: "{n} a" },
  cams: {
    allPlatforms: "Toutes les plateformes",
    watchOnSite: "Regarder sur {site}",
    liveFor: "en direct depuis {time}",
    tryAnother: "Essaie un autre tag ou une autre région, ou reviens dans un moment.",
    nobodyLiveOn: "Personne n’est en direct sur {name} pour le moment",
    platformShowUpHint: "Les lives {name} apparaissent ici dès qu’ils commencent. Reviens dans un moment.",
    liveNowCount: "{n} en direct",
    opensOn: "ils s’ouvrent sur {site}",
    streamerSite: "le site du live",
    orWatch: "Ou regarde {link}.",
    videoTag: "les vidéos #{tag}",
    liveStreams: "Streams en direct",
    platformStreams: "Streams {name} en direct",
    liveCams: "Cams en direct",
    platformCams: "Cams {name}",
    moreLiveCams: "Plus de cams en direct",
    byTopic: "Cams en direct par thème",
    breadcrumb: "Fil d’Ariane",
    live: "En direct",
    viewers: "Spectateurs :",
    isLive: "{name} est en direct",
    watchOn: "{title} — à regarder en direct sur {site}",
    nobodyLive: "Personne n’est en direct pour le moment",
    noMatch: "Aucun stream ne correspond à ces filtres",
    showUpHint: "Les streams s’affichent ici dès qu’ils commencent. Reviens dans un petit moment.",
    clearFilters: "Effacer les filtres",
    clearAll: "Tout effacer",
    clear: "Effacer",
    seeAllPlatforms: "Voir toutes les plateformes",
    watchVideos: "Voir les vidéos",
    onPlatform: " sur {name}",
    newOnTelegram: "Nouvelles cams en direct sur Telegram",
    loadMoreFailed: "Impossible d’en charger plus — réessaie",
    platforms: "Plateformes",
    streamPlatforms: "Plateformes de streaming",
    platformsAndFilters: "Plateformes de streaming et filtres",
    categories: "Catégories",
    all: "Tous",
    region: "Région",
    allRegions: "Toutes les régions",
    more: "Plus",
    newModels: "Nouveaux modèles",
    tags: "Tags",
    removeTag: "Retirer le tag",
    remove: "Retirer",
    loading: "Chargement",
    offline: "Hors ligne",
    seeAll: "Tout voir",
    genders: { female: "Femmes", male: "Hommes", couple: "Couples", trans: "Trans" },
    regions: { north_america: "Amérique du Nord", south_america: "Amérique du Sud", europe: "Europe et Russie", asia: "Asie", other: "Autres régions" },
  },
  video: {
    fullScene: "Voir la scène complète sur {site}",
    upNext: "À suivre",
    nextPage: "Page suivante",
    moreVideos: "Plus de vidéos",
    end: "Tu as tout vu.",
    loadMoreFailed: "Impossible d’en charger plus — réessaie",
    likes: "J’aime",
    premiumVideo: "Vidéo Premium",
    subscribeToWatch: "Abonne-toi pour regarder cette vidéo en entier.",
    getPremium: "Passer à Premium",
    logIn: "Connexion",
    playsIn: "Lecture dans le lecteur de {name}",
    partnerBlocked: "La vidéo est lue depuis les serveurs de {name}, injoignables depuis ton réseau : {name} est peut-être bloqué par ton fournisseur d'accès ou dans ton pays.",
    unavailable: "{name} ne diffuse pas ses vidéos dans ton pays, celle-ci ne peut donc pas être regardée ici.",
    watchCams: "Regarder plutôt des cams en direct",
    chatLive: "Discute en direct avec {name} sur {site}",
    play: "Lire {title}",
    sponsored: "Sponsorisé",
    onlyfansCreators: "Créatrices OnlyFans",
    liveNowFree: "En direct · gratuit",
    allVideos: "Toutes les vidéos",
    stoppedAt: "Arrêtée à {at} sur {of}",
    watchedToEnd: "Regardée jusqu’au bout",
  },
  profile: { followers: "Abonnés", views: "Vues", videos: "Vidéos", verified: "Vérifié", follow: "Suivre", unfollow: "Ne plus suivre" },
  lists: {
    categories: "Catégories",
    popular: "Populaires",
    aToZ: "A – Z",
    jumpToLetter: "Aller à la lettre",
    allCategories: "Toutes les catégories",
    noVideosYet: "Aucune vidéo ici pour l’instant",
    pageN: "Page {n}",
    newEveryDay: "De nouvelles vidéos sont ajoutées chaque jour.",
    videoCount: "{n} vidéos",
    pornstars: "Pornstars",
    pornstarsIntro: "Les stars les plus suivies cette semaine.",
    studios: "Studios porno",
    studiosIntro: "Sociétés de production et chaînes, classées par nombre d’abonnés.",
    noVideosWithTag: "Aucune vidéo avec ce tag",
    showAllVideos: "Afficher toutes les vidéos",
  },
  hot: {
    title: "Chaud en ce moment",
    intro: "Les vidéos les plus regardées sur Sweet ces dernières heures.",
  },
  comments: {
    title: "Commentaires",
    placeholder: "Ajouter un commentaire…",
    post: "Publier",
    login: "Connectez-vous pour commenter",
    coinsHint: "+{n} pièces pour chacun de vos {max} premiers commentaires du jour",
    earned: "+{n} pièces",
    empty: "Aucun commentaire pour l'instant. Soyez le premier.",
    more: "Voir plus",
    delete: "Supprimer",
    short: "Écrivez un peu plus.",
    long: "Trop long : {n} caractères au maximum.",
    links: "Les liens et coordonnées ne sont pas autorisés dans les commentaires.",
    forbidden: "Ce commentaire ne peut pas être publié.",
    rate: "Vous commentez trop vite. Réessayez plus tard.",
    duplicate: "Vous avez déjà publié ceci.",
    failed: "Impossible de publier. Réessayez.",
    like: "J'aime",
    dislike: "Je n'aime pas",
    rateLogin: "Connectez-vous pour noter les vidéos",
    liked: "{p} % aiment",
  },
  starVote: {
    title: "Star du mois",
    vote: "Voter",
    voteFor: "Votez pour {name} comme star du mois",
    voteAgain: "Revoter · {n} pièces",
    confirm: "Dépenser {n} pièces ?",
    standing: "N° {rank} ce mois-ci · votes : {n}",
    noVotes: "Aucun vote ce mois-ci",
    thanks: "Merci pour votre vote !",
    paidThanks: "Vote compté · −{n} pièces",
    coins: "Pas assez de pièces : un vote coûte {n}.",
    limit: "Vous avez utilisé tous vos votes du jour.",
    rules: "Un vote gratuit par jour, puis {n} pièces par vote.",
    boardIntro: "Les membres votent pour leurs stars préférées sur leurs pages : un vote gratuit par jour, d'autres pour {n} pièces chacun.",
    boardEmpty: "Aucun vote ce mois-ci. Votez pour une star sur sa page.",
    votes: "Votes",
    lastWinner: "Star du mois dernier",
    login: "Connectez-vous pour voter",
  },
  achievements: {
    title: "Succès",
    intro: "Débloquez des succès en regardant, en suivant et en participant. Chacun rapporte des Sweet Coins.",
    unlocked: "Débloqué",
    coins: "+{n} pièces",
    progress: "{x} sur {n}",
    total: "{x} sur {n} débloqués",
    login: "Connectez-vous pour obtenir les succès et leurs pièces.",
    signup: "Créer un compte",
    toast: "Succès débloqué",
    names: {
      "videos-1": ["Première vidéo", "Regardez votre première vidéo"],
      "videos-10": ["Échauffement", "Regardez 10 vidéos"],
      "videos-100": ["Habitué", "Regardez 100 vidéos"],
      "videos-1000": ["Connaisseur", "Regardez 1 000 vidéos"],
      "hours-1": ["Une heure", "Regardez pendant une heure"],
      "hours-10": ["Dix heures", "Regardez pendant 10 heures"],
      "hours-100": ["Marathon", "Regardez pendant 100 heures"],
      "streak-3": ["Trois d'affilée", "Regardez 3 jours d'affilée"],
      "streak-7": ["Série d'une semaine", "Regardez chaque jour pendant une semaine"],
      "streak-30": ["Série d'un mois", "Regardez chaque jour pendant 30 jours"],
      "follows-5": ["Fan", "Suivez 5 stars ou studios"],
      "likes-25": ["Grand cœur", "Aimez 25 vidéos"],
      "saves-10": ["Collectionneur", "Enregistrez 10 vidéos"],
      "days-7": ["Semaine de pièces", "Récupérez des pièces 7 jours"],
      "days-30": ["Mois de pièces", "Récupérez des pièces 30 jours"],
      "invites-1": ["Invitez un ami", "Invitez un ami qui s'inscrit"],
      "comments-1": ["Premiers mots", "Écrivez votre premier commentaire"],
      "comments-25": ["Bavard", "Écrivez 25 commentaires"],
      "votes-1": ["Électeur", "Votez pour la star du mois"],
    },
  },
  pwa: {
    appName: "Appli Sweet",
    bannerLabel: "Installer l'appli",
    bannerPitch: "Plein écran, sans store",
    install: "Installer",
    notNow: "Plus tard",
    installApp: "Installer l'appli",
    howToInstall: "Comment l'installer",
    inApp: "Vous utilisez l'appli.",
    cardPitch: "Plein écran, à un geste de votre écran d'accueil. Aucun store nécessaire.",
    manual: "Ouvrez le menu du navigateur et choisissez {install} ou {add}.",
    iosTitle: "Ajoutez Sweet à votre écran d'accueil",
    iosShare: "Touchez {share} dans la barre du navigateur (sur iOS 26 : {more}, puis {share})",
    iosAdd: "Choisissez {add}",
    iosConfirm: "Touchez {confirm} : Sweet s'ouvre en plein écran depuis votre écran d'accueil",
    share: "Partager",
    more: "•••",
    add: "Sur l'écran d'accueil",
    confirm: "Ajouter",
    installMenu: "Installer l'application",
    gotIt: "Compris",
    close: "Fermer",
    offlineTitle: "Vous êtes hors ligne",
    offlineBody: "Sweet a besoin d'Internet pour lire les vidéos et les cams. Vérifiez votre connexion et réessayez.",
    retry: "Réessayer",
    recent: "Ouvertes récemment",
  },
  notifications: {
    title: "Notifications",
    empty: "Rien de nouveau pour l'instant. Suivez des stars et des studios, ou ajoutez des modèles webcam à vos favoris, et leurs nouveautés apparaîtront ici.",
    newVideos: "Nouvelles vidéos",
    liveNow: "En direct",
    markRead: "Tout marquer comme lu",
    pushOn: "Activer les notifications",
    pushOff: "Désactiver les notifications",
    pushHint: "Soyez averti des nouvelles vidéos et de vos favoris en direct, même Sweet fermé.",
    pushBlocked: "Les notifications de Sweet sont bloquées dans les réglages de votre navigateur.",
    pushUnsupported: "Ce navigateur ne peut pas afficher de notifications. Sur iPhone, ajoutez d'abord Sweet à l'écran d'accueil.",
    pushEnabled: "Notifications activées",
    favorites: "Modèles favoris",
    addFavorite: "Ajouter aux favoris",
    removeFavorite: "Retirer des favoris",
    favoritesEmpty: "Pas encore de modèle favori. Touchez le cœur sur une webcam pour en ajouter.",
    offline: "Hors ligne",
    viewAll: "Tout voir",
  },
  forYou: {
    title: "Pour vous",
    all: "Tout",
    continueWatching: "Reprendre",
    intro: "Choisies d'après ce que vous aimez, enregistrez, regardez et suivez.",
    empty: "Aimez, enregistrez ou suivez quelques vidéos et stars, et vous trouverez ici des vidéos choisies pour vous.",
    more: "Plus",
  },
  shorts: {
    straight: "Hétéro",
    gay: "Gay",
    trans: "Trans",
    watchFull: "Voir la vidéo complète",
    like: "J'aime",
    liked: "Aimé",
    save: "Enregistrer",
    saved: "Enregistré",
    share: "Partager",
    copied: "Lien copié",
    soundOn: "Activer le son",
    soundOff: "Couper le son",
    tapForSound: "Touchez pour le son",
    report: "Signaler",
    follow: "Suivre",
    following: "Abonné",
    previous: "Précédent",
    next: "Suivant",
    close: "Fermer",
    end: "C'est tout pour le moment. Plus dans Vidéos.",
    empty: "Pas encore de shorts ici.",
    live: "En direct",
    watchLive: "Regarder en direct gratuitement",
    watching: "{n} spectateurs",
    profile: "Profil",
    moreLive: "Plus de cams en direct",
  },
  search: {
    searches: "Recherches",
    popular: "Recherches populaires",
    categories: "Catégories",
    searchFor: "Rechercher des vidéos « {q} »",
    nothingFor: "Aucun résultat pour « {q} ».",
    title: "Rechercher sur Sweet",
    placeholder: "Rechercher des vidéos, des stars et des marques",
    hint: "Trouve des vidéos, des stars, des productions et des catégories. Appuie sur / n’importe où pour commencer à taper.",
    stars: "Stars",
    productions: "Productions",
    other: "Autres",
    otherProfiles: "Autres profils",
    nothing: "Aucun résultat",
    tryAgain: "Vérifie l’orthographe ou essaie un terme plus large.",
    backHome: "Retour à l’accueil",
  },
  notFound: { title: "Cette page n’existe pas", body: "La vidéo a peut-être été supprimée, ou le lien contient une faute de frappe.", home: "Aller à l’accueil" },
  common: {
    close: "Fermer",
    copy: "Copier",
    copied: "Copié",
    more: "Plus",
    loading: "Chargement",
    clearAll: "Tout effacer",
    browseVideos: "Voir les vidéos",
    scrollLeft: "Défiler vers la gauche",
    scrollRight: "Défiler vers la droite",
  },
  actions: {
    react: "J’aime",
    reacted: "Aimé",
    save: "Enregistrer",
    saved: "Enregistré",
    follow: "Suivre",
    following: "Abonné",
    followName: "Suivre {name}",
    unfollowName: "Ne plus suivre {name}",
    moreOptions: "Plus d’options",
    share: "Partager",
    copyLink: "Copier le lien",
    linkCopied: "Lien copié",
    report: "Signaler",
    home: "Sweet — accueil",
    onSweet: "{name} sur Sweet",
    joinMe: "Rejoins-moi sur Sweet",
    inviteLink: "Ton lien d’invitation",
  },
  library: {
    savedEmpty: "Rien d’enregistré pour l’instant",
    savedHint: "Touche le signet sous une vidéo pour la garder ici. Ta liste est enregistrée sur cet appareil uniquement.",
    reactedEmpty: "Aucune réaction pour l’instant",
    reactedHint: "Les vidéos que tu as aimées apparaissent ici, les plus récentes d’abord.",
    watchingEmpty: "Rien de regardé pour l’instant",
    watchingHint: "Les vidéos que tu lances apparaissent ici avec le moment exact où tu t’es arrêté, et reprennent de là quand tu les rouvres.",
    removeWatching: "Retirer de l’historique",
    removeVideo: "Retirer {title} de l’historique",
    followingEmpty: "Tu ne suis encore personne",
    followingHint: "Touche le + d’un modèle ou d’un studio et ses dernières vidéos se rassembleront ici. Tes abonnements sont enregistrés sur cet appareil uniquement.",
    discoverModels: "Découvrir des modèles",
    noVideosHint: "Essaie une autre catégorie : de nouvelles vidéos arrivent chaque jour.",
    backToAll: "Retour à toutes les vidéos",
  },
  player: {
    resumesAt: "Reprise à {at}",
    startOver: "Recommencer",
    unavailable: "Cette vidéo n’est pas disponible pour le moment.",
    play: "Lecture",
    pause: "Pause",
    seek: "Avancer ou reculer",
    back10: "Reculer de 10 secondes",
    forward10: "Avancer de 10 secondes",
    mute: "Couper le son",
    unmute: "Activer le son",
    volume: "Volume",
    settings: "Paramètres",
    pip: "Image dans l’image",
    fullscreen: "Plein écran",
    exitFullscreen: "Quitter le plein écran",
    quality: "Qualité",
    speed: "Vitesse de lecture",
    normal: "Normale",
    auto: "Auto",
    partner: "le partenaire",
  },
  ads: { ad: "Pub", advertisement: "Publicité", muteAd: "Couper le son de la pub", unmuteAd: "Activer le son de la pub", skipIn: "Passer dans {n}", skipAd: "Passer la pub ›" },
  auth: {
    username: "Nom d’utilisateur",
    usernameOrEmail: "Nom d’utilisateur ou e-mail",
    emailOptional: "E-mail (facultatif)",
    password: "Mot de passe",
    currentPassword: "Mot de passe actuel",
    newPassword: "Nouveau mot de passe",
    confirmPassword: "Confirme le mot de passe",
    confirmNewPassword: "Confirme le nouveau mot de passe",
    showPassword: "Afficher le mot de passe",
    hidePassword: "Masquer le mot de passe",
    forgot: "Mot de passe oublié ?",
    remember: "Rester connecté",
    logIn: "Se connecter",
    createAccount: "Créer un compte",
    usernameHelp: "3 à 24 lettres, chiffres, points ou tirets bas. Affiché dans les classements.",
    emailHelp: "Sert uniquement à réinitialiser ton mot de passe. Tu peux l’ajouter plus tard dans ton compte.",
    passwordHelp: "Au moins 8 caractères.",
    adult: "J’ai 18 ans ou plus.",
    agree: "J’accepte les {terms} et la {privacy}.",
    terms: "Conditions d’utilisation",
    privacy: "Politique de confidentialité",
    savePhrasesTitle: "Enregistre tes phrases de récupération",
    savePhrasesBody: "Tu t’es inscrit sans e-mail : ces phrases sont ton seul moyen de revenir si tu oublies ton mot de passe.",
    continue: "Continuer",
    resetHow: "Comment réinitialiser ton mot de passe",
    byEmail: "Recevoir un lien par e-mail",
    byPhrase: "Phrase de récupération",
    phraseIntro: "Pour les comptes créés sans e-mail : saisis ton nom d’utilisateur et l’une des phrases de récupération enregistrées à l’inscription.",
    phrase: "Phrase de récupération",
    phrasePlaceholder: "mot mot mot mot",
    phraseHelp: "Les 4 mots d’une phrase. Chaque phrase ne sert qu’une fois.",
    saveNewPassword: "Enregistrer le nouveau mot de passe",
    sendLink: "Envoyer le lien de réinitialisation",
  },
  phrases: {
    warning: "Enregistre-les maintenant : elles ne seront plus affichées. Si tu oublies ton mot de passe, ton nom d’utilisateur et l’une de ces phrases te permettent d’en choisir un nouveau. Chaque phrase ne sert qu’une fois. Garde-les pour toi.",
    list: "Tes phrases de récupération",
    copyAll: "Tout copier",
    download: "Télécharger le .txt",
    savedCheck: "J’ai mis mes phrases de récupération en lieu sûr.",
    done: "Terminé",
    fileTitle: "Phrases de récupération Sweet pour @{username}",
    fileHow: "Si tu oublies ton mot de passe, va sur {url}, choisis « {option} » et saisis ton nom d’utilisateur et l’une de ces phrases.",
    filePrivate: "Chaque phrase ne sert qu’une fois. Garde-les pour toi : toute personne ayant ton nom d’utilisateur et l’une de ces phrases peut prendre le contrôle de ton compte.",
    none: "Ton compte n’a ni e-mail ni phrases de récupération. Si tu oublies ton mot de passe, tu ne pourras plus y accéder. Crée des phrases de récupération dès maintenant.",
    optional: "Les phrases de récupération te permettent de choisir un nouveau mot de passe sans e-mail. Facultatives tant que ton compte a un e-mail.",
    left: "{left} phrases sur {total} inutilisées.",
    leftMade: "{left} phrases sur {total} inutilisées, créées le {date}.",
    how: "Chacune, avec ton nom d’utilisateur, te permet de choisir un nouveau mot de passe une fois. Tu les as perdues ? Crées-en de nouvelles et les anciennes ne fonctionneront plus.",
    make: "Créer des phrases de récupération",
    makeNew: "Créer de nouvelles phrases",
  },
  account: {
    menu: "Menu du compte",
    settings: "Paramètres du compte",
    profiles: "Tes profils",
    logOut: "Se déconnecter",
    uploadPhoto: "Importer une photo",
    removePhoto: "Supprimer la photo actuelle",
    displayName: "Nom affiché",
    showInRankings: "M’afficher dans les classements",
    rankingsHelp: "Ton nom, ta photo et tes statistiques de visionnage apparaissent dans les {link} publics. Désactive cette option pour ne pas y figurer ; ton temps est quand même compté.",
    save: "Enregistrer",
    emailHelp: "Sert uniquement à t’envoyer un lien si tu oublies ton mot de passe. Laisse vide pour le supprimer.",
    saveEmail: "Enregistrer l’e-mail",
    changePassword: "Changer le mot de passe",
    deleteWarning: "Ton compte, tes vidéos enregistrées, tes réactions et tes abonnements seront supprimés définitivement. C’est irréversible.",
    typeToConfirm: "Tape {word} pour confirmer",
    deleteMine: "Supprimer mon compte",
  },
  pay: {
    billingPeriod: "Période de facturation",
    monthly: "Mensuel",
    yearly: "Annuel",
    yourPlan: "Ton offre",
    month: "mois",
    year: "an",
    oneMonth: "1 mois",
    months: "{n} mois",
    oneYear: "1 an",
    years: "{n} ans",
    perMonth: "{price} par mois",
    save: "−{n} %",
    comingSoon: "Bientôt",
    reward: "−{n} % ta récompense",
    plays: "{n} parties de Sweet Room",
    addedAtOnce: "Ajoutées tout de suite",
    get: "Prendre {plan}",
    addMonth: "Ajouter un mois",
    addYear: "Ajouter un an",
    opensSoon: "Paiements bientôt ouverts",
    alreadyMember: "Déjà membre ?",
    choose: "Choisis comment payer",
    payWith: "Payer avec",
    starsInBot: "{n} Stars dans notre bot Telegram",
    card: "Carte",
    crypto: "Crypto",
    cryptoMore: "BTC, USDT, ETH, TON et plus de 30 autres",
    tooManyStars: "Trop élevé pour un seul paiement en Telegram Stars.",
    cardMin: "Paiement par carte à partir de {price}.",
    payStars: "Payer en Telegram Stars",
    preparing: "Préparation du paiement…",
    loginFirst: "Connecte-toi d’abord",
    cantStart: "Impossible de lancer le paiement",
    noAdsCoins: "Sans pub + {n} Sweet Coins",
    addedOnPay: "Ajoutées à ton solde dès que tu paies",
    payInTelegram: "Payer dans Telegram",
    waitingStars: "En attente de ton paiement — cette page se met à jour toute seule",
    allSet: "C’est fait !",
    noAds: "Plus de pub.",
    noAdsUntil: "Sans pub jusqu’au {date}.",
    coinsAdded: "{n} pièces sont sur ton solde.",
    startWatching: "Commencer à regarder",
    great: "Super",
    payCard: "Payer par carte",
    failedTitle: "Le paiement n’est pas passé",
    failedBody: "Rien n’a été débité. Tu peux réessayer.",
    newTab: "Paie dans le nouvel onglet",
    newTabBody: "Carte, Apple Pay ou Google Pay, sur la page sécurisée de Chain2Pay. Cette page se met à jour toute seule une fois le paiement effectué.",
    waiting: "En attente de ton paiement…",
    openAgain: "Rouvrir la page de paiement",
    somethingWrong: "Un problème est survenu. Réessaie dans une minute.",
    offline: "Tu sembles hors ligne. Réessaie dans une minute.",
    bestValue: "Meilleur prix",
    coins: "pièces",
    orStars: "ou {n} Stars",
    packsSoon: "Les packs de pièces seront bientôt en vente.",
    nCoins: "{n} Sweet Coins",
    collected: "+{n} Sweet Coins récupérées !",
    collectedToday: "Récupérées aujourd’hui",
    nextBonus: "Prochain bonus dans",
    collecting: "Récupération…",
    collect: "Récupérer {n} Sweet Coins",
    alreadyCollected: "Tu as déjà récupéré les pièces du jour. Reviens demain.",
    offerLabel: "Sweet Coins et Premium",
    offerTitle: "Obtiens des Sweet Coins",
    offerFor: "Pour Sweet Room et les vidéos payantes",
    premiumFrom: "Premium dès {price}",
    upTo: "Sans pub + jusqu’à {n} pièces",
    packsFrom: "Packs de pièces dès {price}",
    collectFree: "Ou récupère des pièces gratuites chaque jour",
    offerButton: "Offre Sweet Coins",
    guestCollected: "+{n} Sweet Coins ! Pour ne pas perdre tes pièces, inscris-toi sur Sweet.",
    guestKeep: "Sans compte, les pièces sont gardées {days} jours, puis perdues.",
    guestSignup: "S’inscrire gratuitement et les garder",
    guestLogin: "Déjà un compte ? Se connecter",
    guestExpire: "{n} pièces seront perdues le {date}.",
    guestUnsaved: "Tes pièces ne sont pas encore enregistrées : inscris-toi pour les garder",
    guestExpiring: "{n} de tes Sweet Coins seront perdues dans moins d’un jour. Inscris-toi gratuitement pour les garder.",
  },
  footer: {
    copyright: "Droits d’auteur",
    takedown: "Retrait de contenu",
    contact: "Contact",
    creators: "Créateurs",
    claim: "Revendiquer son profil",
    webmasters: "Webmasters",
    terms: "Conditions",
    privacy: "Confidentialité",
    info: "Informations sur le site",
    telegram: "{site} sur Telegram",
  },
  report: {
    heading: "Signaler une vidéo",
    reason: "Motif",
    takedown: "Droits d’auteur / DMCA",
    abuse: "J’apparais dans cette vidéo sans mon consentement",
    minor: "Une personne dans cette vidéo pourrait avoir moins de 18 ans",
    other: "Autre chose",
    url: "Lien ou identifiant de la vidéo",
    email: "Ton e-mail",
    details: "Détails",
    detailsPlaceholder: "Que devons-nous retirer et pourquoi ?",
    send: "Envoyer le signalement",
  },
};
